<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('scope.text_286')"
    icon="menu-tenant"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <template v-slot:actions>
      <actions
        :options="singleActions"
        :row="detailData"
        button-type="link"
        button-size="small" />
    </template>
    <component
      :is="params.windowData.currentTab"
      :data="detailData"
      :serverColumns="columns"
      :res-id="data.id"
      :getParams="getParams"
      :on-manager="onManager"
      @refresh="refresh"
      @single-refresh="singleRefresh"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import SingleActionsMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'
import ReportProjectList from '../../report-project/components/List'
import ChannelDetail from './Detail'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import Actions from '@/components/PageList/Actions'

export default {
  name: 'ChannelManagerSidePage',
  components: {
    Actions,
    ChannelDetail,
    ReportProjectList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin, SingleActionsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('scope.text_433'), key: 'channel-detail' },
        { label: this.$t('scope.text_502'), key: 'report-project-list' },
        { label: this.$t('scope.text_435'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      if (this.params.windowData.currentTab === 'report-project-list') {
        return {
          customer_id: this.data.id,
        }
      }
      return null
    },
  },
}
</script>
